<div class="form-title" class="marlinFormGroup">
    <h3 [innerHTML]="'gblPoliciesUpdated' | translate"></h3>
    <div class="pt-2 terms-conditions">
        <label>
            <span [innerHTML]="'gblPleaseReadPolicies' | translate"></span>
            <a class="ps-1" [href]="policiesUrl" [innerHTML]="'gblHere' | translate"></a>.
        </label>
        <label class="pt-2" [innerHTML]="'gblPrivacyDataTermsAndConditionsAgreement' | translate"></label>
        <label class="pt-2" [innerHTML]="'gblCookiesAgreement' | translate"></label>
    </div>
    <div class="mb-3 pt-2">
        <div class="form-check form-check-inline terms-conditions">
            <input class="form-check-input" type="checkbox" [value]="1" id="policyAcceptance" />
            <label class="form-check-label" for="policyAcceptance" [innerHTML]="'gblAccept' | translate"> </label>
        </div>
    </div>
    <div class="mb-3">
        <button class="btn btn-primary w-100" (click)="submit()" [innerHTML]="'lclSubmit' | translate"></button>
    </div>
</div>
